import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import DialogTitle from '@mui/material/DialogTitle';
import { useTravlData } from './TravlContext';
import { mapTravlToSiteAndSurveyArray } from './TravlHelpers/extractDataToSiteAndSurvey';

interface IProps {
    open: boolean;
    onClose: () => void;
    landUse: string;
}

export default function ExportToCsvDialog(props: IProps) {
    const { open, onClose, landUse } = props;
    const { siteData } = useTravlData();

    const exportCsv = () => {
        const dataToExport = mapTravlToSiteAndSurveyArray(siteData.filter(f=> f.LandUseDesc === landUse || landUse === 'All Surveys'));

        if (!dataToExport.length) {
            onClose();
            return;
        }

        const headers = Object.keys(dataToExport[0]);

        const rows = [
            headers.join(","), 
            ...dataToExport.map(obj =>
                headers.map(h => {
                    const val = obj[h] ?? "";
                    const safeVal = String(val).replace(/"/g, '""');
                    return `"${safeVal}"`;
                }).join(",")
            )
        ];

        const csvContent = "data:text/csv;charset=utf-8," + rows.join("\n");
        const encodedUri = encodeURI(csvContent);
        const link = document.createElement("a");
        link.setAttribute("href", encodedUri);
        link.setAttribute("download", "exported_data.csv");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        onClose();
    };


    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="sm"
            fullWidth
        >
            <DialogTitle>Export to CSV</DialogTitle>
            <DialogContent>
                Click OK to download the CSV file to your PC
                <DialogActions>
                    <Button onClick={exportCsv}>
                        Ok
                    </Button>
                    <Button onClick={() => onClose()}>
                        Cancel
                    </Button>
                </DialogActions>
            </DialogContent>
        </Dialog>
    );
}